// extracted by mini-css-extract-plugin
export default {"default":"FormCard_default__GP75M","header":"FormCard_header__z+fGQ","title":"FormCard_title__hJ5ha","detail":"FormCard_detail__+Ofz5","body":"FormCard_body__GR-SV"};